module.exports = __webpack_public_path__ + "img/magnifying-glass-regular.c8bda4b1.svg";